module.exports = __webpack_public_path__ + "pc/img/main-magazine-img-01.c120cb52.png";